import { HorizontalDivider, VerticalDivider } from "@@/shared/dividers";
import { usePageBreakpoint } from "@@/shared/responsiveness/use-page-breakpoint";
import { SectionArea } from "@@/shared/section-area";
import { SectionAreaList } from "@@/shared/section-area/section-area-list";
import { useProductIdWithFallback } from "@@/store-fronts/shared/fallback-product-ids";
import { useHzCardSize } from "@@/store-fronts/use-hz-card-size";
import type { ProductId, RemSize} from "@towni/common";
import { translation } from "@towni/common";
import * as React from "react";
import type { FC } from "react";
import { ResponsiveStoreFrontHzProductCard } from "../../shared/store-front-hz-product-card";
import { kronocampingColors } from "../kronocamping-color-context";

const KronocampingLateSummerSection: FC = () => {
    const isDesktop = usePageBreakpoint({ when: "🖥" });
    const cardSize = useHzCardSize(1.35 as RemSize);
    const getProductId = useProductIdWithFallback();

    const productIds = React.useMemo(
        () => [
            // Campingbio
            getProductId("product__HrxSPHJzY9P9Wv-j8C6C" as ProductId),
            //Campingbio - för dem yngre
            getProductId("product__cyfY-NIypwnbX4StMIL2" as ProductId),
            // Campingkuls Utomhusbio - Jurassic World
            getProductId("product__CBICiNM5Z7FTF0hUK1VD" as ProductId),
            // Campingkuls Utomhusbio - Jurassic World
            getProductId("product__nHCtEt5mUkkK62UPQwHz" as ProductId),
        ],
        []
    );

    return (
        <SectionArea
            sectionAreaId="kronocamping-late-summer-exercise"
            title="Sensommarbio"
            subtitle="Vi har mycket för att göra din vistelse full av liv och rörelse"
            background={{
                color: kronocampingColors.lightBackground,
            }}
            css={{
                borderRadius: isDesktop ? 10 : 0,
            }}
            padding={isDesktop ? { all: 10 } : { topBottom: 10 }}>
            <SectionAreaList
                scroll={true}
                contentMargin={15}
                padding={{
                    bottom: 20,
                    left: 20,
                }}>
                <ResponsiveStoreFrontHzProductCard
                    cardSize={cardSize}
                    productId={productIds[0]}
                    actionText={text.explore}
                    actionTextColorSet={kronocampingColors.secondary}
                    aspectRatio="3:4"
                    subtitleSize={0.93 as RemSize}
                    hideKicker
                />
                <ResponsiveStoreFrontHzProductCard
                    cardSize={cardSize}
                    productId={productIds[1]}
                    actionText={text.seemore}
                    actionTextColorSet={kronocampingColors.primary}
                    aspectRatio="3:4"
                    subtitleSize={0.93 as RemSize}
                    hideKicker
                />
                <ResponsiveStoreFrontHzProductCard
                    cardSize={cardSize}
                    productId={productIds[2]}
                    actionText={text.book}
                    actionTextColorSet={kronocampingColors.secondary}
                    aspectRatio="3:4"
                    subtitleSize={0.93 as RemSize}
                    hideKicker
                />
                <ResponsiveStoreFrontHzProductCard
                    cardSize={cardSize}
                    productId={productIds[3]}
                    actionText={text.book}
                    actionTextColorSet={kronocampingColors.primary}
                    aspectRatio="3:4"
                    subtitleSize={0.93 as RemSize}
                    hideKicker
                />
                <HorizontalDivider size="L" />
            </SectionAreaList>
            <VerticalDivider M />
        </SectionArea>
    );
};

const text = {
    book: translation({
        sv: "Boka",
        en: "Explore",
    }),
    seemore: translation({
        sv: "Se mer",
        en: "Explore",
    }),
    explore: translation({
        sv: "Utforska",
        en: "Explore",
    }),
};

export { KronocampingLateSummerSection };
